export const DEFAULT_BUSINESS_HOURS = 8

export const formatLeaveDuration = (
  numberOfDays,
  t,
  businessHours = DEFAULT_BUSINESS_HOURS
) => {
  if (
    numberOfDays === null ||
    numberOfDays === undefined ||
    numberOfDays === ''
  ) {
    return '-'
  }

  const daysValue = Number(numberOfDays)
  const hoursPerDay = Number(businessHours) || DEFAULT_BUSINESS_HOURS

  if (!Number.isFinite(daysValue)) {
    return '-'
  }

  const totalMinutes = Math.round(daysValue * hoursPerDay * 60)
  const minutesPerDay = hoursPerDay * 60
  const days = Math.floor(totalMinutes / minutesPerDay)
  const remainingMinutes = totalMinutes % minutesPerDay
  const hours = Math.floor(remainingMinutes / 60)
  const minutes = remainingMinutes % 60
  const parts = []

  if (days) {
    parts.push(`${days} ${t('common.unit.date.day')}`)
  }

  if (hours) {
    parts.push(`${hours} ${t('common.unit.date.hour')}`)
  }

  if (minutes) {
    parts.push(`${minutes} ${t('common.unit.date.minute')}`)
  }

  return parts.length ? parts.join(' ') : `0 ${t('common.unit.date.day')}`
}
